<template>
  <div class="space-y-3 rounded-lg border border-gray-700 bg-gray-900 p-4">
    <div class="border-b border-gray-700 pb-2 text-sm font-semibold text-gray-300">LED Statistics</div>

    <div class="grid grid-cols-2 gap-4 text-xs" v-if="ledPanelData">
      <div class="space-y-1">
        <div class="text-gray-400">Name</div>
        <div class="text-white">{{ ledPanelData.brand?.name }} {{ ledPanelData?.name }}</div>
        <br />
        <div class="text-gray-400">Panel Width</div>
        <div class="text-white">{{ formatLength(ledPanelData.panel_width_mm / 1000, 2) }}</div>

        <div class="text-gray-400">Panel Height</div>
        <div class="text-white">{{ formatLength(ledPanelData.panel_height_mm / 1000, 2) }}</div>

        <div class="text-gray-400">Resolution</div>
        <div class="text-white">
          {{ ledPanelData.resolution_width }} x
          {{ ledPanelData.resolution_height }}
        </div>
        <br />
        <div class="text-gray-400">Nits</div>
        <div class="text-white">
          {{ ledPanelData.brightness_nits }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useNodeManager } from '@/composables/useNodeManager';
import { useUnitConversion } from '@/composables/useUnitConversion';
import { useLedPanelStore } from '@/stores/api/ledpanel';
import { useSelectionStore } from '@/stores/ui/selection';
import { ref, watch } from 'vue';

const selectionStore = useSelectionStore();
const { findNodeById } = useNodeManager();
const ledPanelStore = useLedPanelStore();
const { formatLength } = useUnitConversion();

const ledPanelData = ref(null);

watch(
  () => {
    const selectedId = selectionStore.selectedObjectId;
    const node = findNodeById(selectedId);
    return {
      selectedId,
      libraryCode: node?.data?.libraryCode,
    };
  },
  (newValue, oldValue) => {
    if (newValue.libraryCode && newValue.libraryCode !== oldValue?.libraryCode) {
      ledPanelStore.fetch(newValue.libraryCode).then((resp) => {
        ledPanelData.value = resp;
      });
    } else if (!newValue.libraryCode) {
      ledPanelData.value = null;
    }
  },
  { immediate: true }
);
</script>
